/**
 * The PropertyDefinition object has too many required properties and TS requires all of the stuff
 * below when creating a property.
 * This method simplifies the creation process by setting the defaults and overriding only what's necessary.
 */
export function createPropertyDefinition(propertyDefinition) {
  return Object.assign({
    calculated: false,
    createdAt: 0,
    createdUserId: null,
    currencyPropertyName: null,
    deleted: false,
    description: '',
    displayOrder: 0,
    externalOptions: false,
    externalOptionsReferenceType: null,
    favorited: false,
    favoritedOrder: 0,
    fieldType: 'text',
    formField: false,
    groupName: '',
    hasUniqueValue: false,
    hidden: false,
    hubspotDefined: false,
    isCustomizedDefault: false,
    label: '',
    mutableDefinitionNotDeletable: false,
    name: '',
    options: [],
    optionsAreMutable: null,
    optionSortStrategy: null,
    readOnlyDefinition: false,
    readOnlyValue: false,
    referencedObjectType: null,
    searchableInGlobalSearch: false,
    showCurrencySymbol: false,
    type: 'string',
    updatedAt: null,
    updatedUserId: null
  }, propertyDefinition);
}
export function propertyGroupsToPropertyDefinitions(propertyGroups) {
  if (propertyGroups.length === 0) {
    return [];
  }
  return propertyGroups.map(result => result.properties).flat();
}